<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import Store from '@/store'
import { TweenMax as Tween, TimelineMax as Line, Power1 } from 'gsap'
import find from 'lodash/find'

import TransitionWrapper from '@/layout/wrappers/transition-wrapper'
import BaseButton from '@/components/base-button'

export default {

  name: 'ContactsPage',

  components: {
    TransitionWrapper,
    BaseButton
  },

  computed: {
    isFormOpened () {
      return this.$store.state.form.opened
    },

    $content () {
      return this.$store.state.pages.landings.contacts
    },

    contacts () {
      return this.$content.address
    },

    formData () {
      return find(this.$content.contacts)
    },

    windowWidth(){
      return this.$store.state.app.window.width
    }
  },

  created () {
    if (this.contacts === undefined || this.formData === undefined) {
      this.$router.push('/not-found')
    }
    this.setTitle();
  },

  beforeRouteEnter: async (to, from, next) => {
    Store.commit('startLoading')

    const page = await Store.dispatch('pages/fetchLanding', 'contacts')
    const errors = []

    if (!page.contacts) errors.push('Contacts page must have a contacts widget.2')

      Store.commit('endLoading')

    if (errors.length > 0) {
      next({
        path: '/' + (from.params.lang || 'ua') + '/error',
        query: { code: 500, errors }
      })
      return
    }

    next()
  },

  beforeRouteUpdate: async (to, from, next) => {
    if (from.params.lang === to.params.lang) {
      next();
      return
    }

    Store.commit('startLoading');

    const page = await Store.dispatch('pages/fetchLanding', 'contacts');
    const errors = [];
    if (!page.contacts) errors.push('Contacts page must have a contacts widget.');

      Store.commit('endLoading');

    if (errors.length > 0) {
      next({
        path: '/' + (from.params.lang || 'ua') + '/error',
        query: { code: 500, errors }
      });
      return
    }

    next()
  },

  methods: {

    setTitle(){
      let title = document.getElementsByTagName('title')[0];
      return title.text = this.$content.meta.title;
    },

    enter () {
      const tl = new Line()

//for forms
//      tl.from(this.$refs.background, 1, {
//        scaleY: 0,
//        ease: Power1.easeOut
//      })
//
//      tl.from(this.$refs.button, 1, {
//        autoAlpha: 0,
//        y: -40,
//        ease: Power1.easeOut,
//        onStart: () => {
//          if (this.$refs.button) {
//            this.$refs.button.setAttribute('disabled', true)
//          }
//        },
//        onComplete: () => {
//          if (this.$refs.button) {
//            this.$refs.button.removeAttribute('style')
//            this.$refs.button.removeAttribute('disabled')
//          }
//        }
//      }, 0.4)
//end forms

      const els = [
        ...this.$refs.contacts
      ]


      tl.staggerFrom(els, 1, {
        autoAlpha: 0,
        y: -40,
        ease: Power1.easeOut
      }, 0.1, 0.5)
    },

    leave (el, done) {
      if (this.$store.state.app.routeChangedFromPopup) {
        done()
      } else {
        Tween.to(el, 0.5, {
          autoAlpha: 0,
          ease: Power1.easeOut,
          onComplete: done
        })
      }
    },

    openForm () {
      this.$store.dispatch('openPopup', 'form')
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.contacts-page
  .wrapper

    .contacts-page__main
      .contacts-page__container

        transition(name="fade")
          ul.contacts-list(v-if="!isFormOpened")
            li.contact(v-for="contact in contacts" ref="contacts")
              .contact__label {{ contact.label }}
              .contact__value {{ contact.content }}
              base-button.map-link(
              v-if="!isFormOpened && contact.url.length > 0 && contact.labelUrl.length > 0",
              :url="contact.url" ,
              :label="contact.labelUrl",
              ref="mapButton")

    .contacts-page__aside.aside-container(v-if="this.windowWidth > 1024")
      .aside-inner

        .aside-inner__background(:class="{ 'is-wide': isFormOpened }" ref="background")

        transition(name="fade")
          button.trigger(v-if="!isFormOpened" type="button" ref="button" @click="openForm")
            .trigger__wrap
              img.trigger__icon(src="../../assets/form-icon.svg" alt="form icon")
              span.trigger__label(v-html="$t('write-to-us')")

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.wrapper
  display flex
  justify-content space-between
  width 100%

  +below(1024px)
    flex-direction column-reverse
    justify-content flex-end

.contacts-page
  display flex
  flex-direction row !important
  justify-content center
  min-height 100vh

  &__main
    display flex
    flex-direction column
    justify-content center
    align-items center
    width 55%
    padding-top 130px
    padding-bottom 43px
    min-height: 100%

    +below(1024px)
      width 100%
      padding 120px 0

    +mobile()
      padding 55px 48px 80px

  &__container
    max-width 400px
    width 100%

    .button
      display inline-flex

// ===========================================
// Main
// ===========================================

.contacts-list
  list-style-type none
  display flex
  flex-direction column

.contact
  display flex
  flex-direction column

  &~&
    margin-top: 30px
  &__label
    font-weight 500
    font-size 12px
    line-height 11px
    color blue

  &__value
    margin-top 20px
    font-weight 300
    font-size 26px
    line-height 34px

    +mobile()
      font-size 17px
      line-height 21px

.map-link
  margin-top 40px

// ===========================================
// Aside
// ===========================================

.aside-container
  position relative
  flex 0 0 auto
  width 45%
  height 100%

  +below(1024px)
    width 100%
    height auto
    padding 250px 0 110px

  +mobile()
    padding 165px 0 100px

.aside-inner
  position absolute
  top 0
  left 0
  width 100%
  // width calc((100vw - 1008px) / 2 + 448px)
  height 100%
  display flex
  align-items center

  +below(1024px)
    justify-content center

  &__background
    z-index 1
    position absolute
    top 0
    right 0
    display block
    width 100%
    height 100%
    background-color blue
    transform-origin top right
    transition width 1s ease-out

    &.is-wide
      width 100vw
      min-height 100vh
      transition width 0.5s ease-out

.trigger
  z-index 2
  position relative
  display flex

  &__wrap
    display flex
    padding 76px

    +hd()
      padding 140px

    +below(1024px)
      padding 30px
      width 100%

  &__icon
    align-self flex-start
    margin-top 5px

  &__label
    font-family 'Gotham Pro'
    font-weight 500
    font-size 26px
    line-height 34px
    color white
    margin-left 24px
    text-align left

    +below(1024px)
      br
        display none

// ===========================================
// Animation
// ===========================================

.fade-enter
.fade-leave-to
  opacity 0
  visibility hidden

time = 0.5s
delay = 0.5s

.fade-enter-active
  transition opacity time delay, visibility time delay
.fade-leave-active
  transition opacity time, visibility time

</style>



// WEBPACK FOOTER //
// index.vue?2a113145